<template>
  <div>
    <v-btn
      v-if="gameWeek.isEnded() || gameWeek.isWaiting()"
      color="primary"
      height="40px"
      :loading="isLoading"
      @click="toggleGameWeekStatus"
    >
      <font-awesome-icon
        :icon="['fas', gameWeekStatusIcon]"
        class="mr-2"
      />
      {{ gameWeekStatusText }}
    </v-btn>
  </div>
</template>

<script>
import GameWeek from '@/models/GameWeek/gameWeek.js'
import GameWeekService from '@/services/gameWeek.service.js'

export default {
  name: 'GameWeekAction',
  props: {
    gameWeek: {
      type: GameWeek,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    gameWeekStatusIcon() {
      return this.gameWeek.isEnded() ? 'fa-lock-open' : 'fa-lock';
    },
    gameWeekStatusText() {
      return this.gameWeek.isEnded() ? 'Ouvrir' : 'Fermer';
    },
  },
  methods: {
    toggleGameWeekStatus() {
      if (this.gameWeek.isEnded()) {
        this.openGameWeek();
      } else {
        this.closeGameWeek();
      }
    },
    closeGameWeek() {
      this.isLoading = true;
      GameWeekService.closeGameWeek(this.gameWeek.number)
        .then((gameWeek) => {
          this.$emit('gameWeekUpdate', gameWeek);
        })
        .finally(() => this.isLoading = false)
    },
    openGameWeek() {
      this.isLoading = true;
      GameWeekService.openGameWeek(this.gameWeek.number)
        .then((gameWeek) => {
          this.$emit('gameWeekUpdate', gameWeek);
        })
        .finally(() => this.isLoading = false)
    },
  },
}
</script>

<style scoped lang="scss">
.text-panel-gw {
  display: flex;
  justify-content: center;
}
</style>
